import {
	LEGACY_EXTENSION_LOADING_CUSTOM_KEY,
	createConcurrentCustomMetric,
} from '@confluence/browser-metrics';

export const LEGACY_EXTENSION_LOADING_METRIC = createConcurrentCustomMetric({
	key: LEGACY_EXTENSION_LOADING_CUSTOM_KEY,
});
